import type { MemoAccessRoleValue, MemoRoleValue } from "@portal/schemas";

/** 共有の権限の表示名(Google ドライブに合わせる)。 */
export const MEMO_ROLE_LABELS: Record<MemoRoleValue, string> = {
  VIEWER: "閲覧者",
  EDITOR: "編集者",
};

export const MEMO_ACCESS_LABELS: Record<MemoAccessRoleValue, string> = {
  OWNER: "所有者",
  EDITOR: "編集可",
  VIEWER: "閲覧のみ",
};
